import React from 'react';
import ticketsService from '../../services/tickets';
import './PostalEntry.css';

const EnvelopeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M4 6.75C4 5.7835 4.7835 5 5.75 5H18.25C19.2165 5 20 5.7835 20 6.75V17.25C20 18.2165 19.2165 19 18.25 19H5.75C4.7835 19 4 18.2165 4 17.25V6.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5 7L12 12.5L19 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PostalEntry = ({ loading, theme, size, is341 = false }) => {
  if (is341) {
    return (
      <div
        className={`postal-card postal-card--341 ${
          size === 'lg' ? 'postal-card--lg' : ''
        }`}
      >
        <div className="postal-card__bg" aria-hidden="true">
          <span />
          <span />
        </div>
        <div className="postal-card__content">
          <div className="postal-card__icon">
            <EnvelopeIcon />
          </div>
          <div className="postal-card__text">
            <p className="postal-card__title">No purchase necessary</p>
            <p className="postal-card__subtitle">Postal entry</p>
          </div>
        </div>
        <button
          onClick={ticketsService.goToPost}
          disabled={loading}
          className="postal-card__btn postal-card__btn--341"
          type="button"
        >
          More info
        </button>
      </div>
    );
  }

  return (
    <div
      className={`postal-card ${
        theme === 'light' ? 'postal-card_white' : 'postal-card_green'
      } ${size === 'lg' ? 'postal-card--lg' : ''}`}
    >
      <div className="info">
        <div className="details details-rows">
          <p className="details-row">Postal entry</p>
        </div>
        <div className="price">
          <p>No purchase necessary</p>
        </div>
      </div>
      <button
        onClick={ticketsService.goToPost}
        disabled={loading}
        className="postal-card__btn"
        type="button"
      >
        More info
      </button>
    </div>
  );
};

export default PostalEntry;
